import axios from "axios";

import { refreshToken as refreshTokenApi } from "./apiCalls/auth";

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const originalRequest = error.config;
    const refreshToken = localStorage.getItem("refresh_token");
    if (
      refreshToken &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      return refreshTokenApi().then((res) => {
        if (res?.data?.access_token) {
          originalRequest._retry = true;
          originalRequest.headers.Authorization = `Bearer ${res?.data?.access_token}`;
          return axios(originalRequest);
        }
        return Promise.reject(error);
      });
    }
    return Promise.reject(error);
  },
);